// extracted by mini-css-extract-plugin
export default {"home":"style_home__ELN5Z","home__buttons":"style_home__buttons__pIMhr"};